import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import CustomNavbar from './CustomNavbar';
import { useApp } from '../AppContext';
import './css/Dashboard.css';
import Notifications from './Notifications';
import Calendar from './calendar';
import PushNotifications from './pushNotifications';
import cfg from '../config';
import api from './axiosSetup';
import moment from 'moment';
import 'moment/locale/de';

moment.locale('de');

const authHeader = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` } });

const Dashboard = () => {
  const { isOn } = useApp();
  const [firstName, setFirstName] = useState('');
  const location = useLocation();
  const [dashData, setDashData] = useState(null);
  const [dashLoading, setDashLoading] = useState(true);

  useEffect(() => {
    setFirstName(localStorage.getItem('firstName') || '');
    api.get('/api/dashboard', authHeader())
      .then(r => setDashData(r.data))
      .catch(() => setDashData(null))
      .finally(() => setDashLoading(false));
  }, []);

  const { nextMove, nextWorkAssignments = [], haeser = [] } = dashData || {};

  return (
    <div>
      <CustomNavbar />

      <div className="container mt-4">
        <h1 className="mb-1">Willkommen, {firstName}!</h1>
        <p className="text-secondary mb-4">Was gibt's Neues?</p>

        {location.state?.message && (
          <div className="alert alert-success">{location.state.message}</div>
        )}

        {/* Push-Benachrichtigungen */}
        <div className="mb-3">
          <PushNotifications />
        </div>

        {/* ── Übersichtskarten ── */}
        {!dashLoading && (
          <div className="row g-3 mb-4">
            {/* Nächster Umzug */}
            <div className="col-12 col-md-4">
              <div className="card bg-secondary text-white h-100">
                <div className="card-body">
                  <h6 className="card-subtitle mb-2 text-warning fw-bold text-uppercase" style={{ fontSize: 11, letterSpacing: 1 }}>
                    Nächste Veranstaltung
                  </h6>
                  {nextMove ? (
                    <>
                      <h5 className="card-title mb-1">{nextMove.city}</h5>
                      <p className="card-text mb-2" style={{ fontSize: 14 }}>
                        {moment(nextMove.date).format('dddd, DD. MMMM YYYY')}
                      </p>
                      <Link to="/move-table" className="btn btn-warning btn-sm">Zur Übersicht</Link>
                    </>
                  ) : (
                    <p className="card-text text-white-50 small">Keine bevorstehenden Buchungen</p>
                  )}
                </div>
              </div>
            </div>

            {/* Arbeitseinsätze */}
            <div className="col-12 col-md-4">
              <div className="card bg-secondary text-white h-100">
                <div className="card-body">
                  <h6 className="card-subtitle mb-2 text-warning fw-bold text-uppercase" style={{ fontSize: 11, letterSpacing: 1 }}>
                    Meine Arbeitseinsätze
                  </h6>
                  {nextWorkAssignments.length > 0 ? (
                    <ul className="list-unstyled mb-2" style={{ fontSize: 14 }}>
                      {nextWorkAssignments.map((w, i) => (
                        <li key={i} className="mb-1">
                          <strong>{w.name}</strong><br />
                          <span className="text-white-50">{moment(w.date).format('DD.MM.YYYY')} · {w.timeFrom?.slice(0, 5)}–{w.timeTo?.slice(0, 5)} Uhr</span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="card-text text-white-50 small">Keine bevorstehenden Arbeitseinsätze</p>
                  )}
                  <Link to="/swap-boerse" className="btn btn-warning btn-sm">Alle anzeigen</Link>
                </div>
              </div>
            </div>

            {/* Häs-Status */}
            {isOn('Modul_Haes') && (
            <div className="col-12 col-md-4">
              <div className="card bg-secondary text-white h-100">
                <div className="card-body">
                  <h6 className="card-subtitle mb-2 text-warning fw-bold text-uppercase" style={{ fontSize: 11, letterSpacing: 1 }}>
                    {/* Ohne Artikel: welcher passt, haengt vom eingestellten
                        Begriff ab - "Mein Häs", aber "Meine Kleidung". */}
                    {cfg.costumeTermPlural}
                  </h6>
                  {haeser.length > 0 ? (
                    <ul className="list-unstyled mb-2" style={{ fontSize: 14 }}>
                      {haeser.map((h, i) => (
                        <li key={i} className="mb-1 d-flex align-items-center gap-2">
                          <span>{h.typ} Nr. {h.number}</span>
                          {h.lent && <span className="badge bg-warning text-dark" style={{ fontSize: 10 }}>Verliehen</span>}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="card-text text-white-50 small">Nichts zugewiesen</p>
                  )}
                  <Link to="/meine-daten" className="btn btn-warning btn-sm">Meine Daten</Link>
                </div>
              </div>
            </div>
            )}
          </div>
        )}

        <Notifications />
        <Calendar />
      </div>
    </div>
  );
};

export default Dashboard;
